export default __webpack_public_path__ + "static/media/squares.5751874a.svg";